var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 40.03",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5V45H50V5ZM17.61,35.25v2.93H6.84V27.4H9.76v5.78l9.08-9.07,2.07,2.07-9.07,9.07ZM43.15,22.6H40.23V16.82l-9.07,9.07-2.07-2.07,9.07-9.07H32.38V11.82H43.15Z",
    transform: "translate(0 -4.98)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullScreen);
export default __webpack_public_path__ + "static/media/icon-full-screen.628d507133be1bae9c9d70464a72fb7a.svg";
export { ForwardRef as ReactComponent };